import 'angular:locale/data:pl-PL';
import 'angular:locale/data:de-DE';
import 'angular:locale/data:zh-TW';
import 'angular:locale/data:zh-CN';
import 'angular:locale/data:ja-JP';
import 'angular:locale/data:pt-PT';
import 'angular:locale/data:fr-FR';
import 'angular:locale/data:nl-NL';
import 'angular:locale/data:es-ES';
import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
